import { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { $host } from "../../../http"

import CourseCard from "../components/cards/CourseCard"
import PageTitle from "../PageTitle"
import AddCard from "../components/cards/AddCard"
import CardTag from "../components/cards/CardTag"
import BreadcrumbsBase from "../components/buttons/Breadcrumbs"

import generateBreadcrumbs from "../utils/breadcrumbs"

const TeachersCoursesTopics = () => {
    const [themes, setTopics] = useState([])
    const { id: sectionId } = useParams()
    const [breadcrumbs, setBreadcrumbs] = useState([])  
    const [pageTitle, setPageTitle] = useState('')

    const navigate = useNavigate()


    const fetchThemes = async () => {
        try {
            const {data} = await $host.get(`/api/students/paragraphs/themes/${sectionId}`)
            setTopics(data.themes)
            setPageTitle(data.breadcrumbs.paragraph_title)
            setBreadcrumbs(generateBreadcrumbs(data.breadcrumbs))
        } catch(e) {
            console.error(e)
        }
        
    }

    useEffect(() => {
        fetchThemes()
    }, [sectionId])

    const deleteTheme = async (themeId) => {
        try {
            await $host.delete(`/api/teachers/themes/${themeId}`)
            fetchThemes()
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <section className="py-10 px-6 w-full">
            <BreadcrumbsBase items={breadcrumbs} />
            <PageTitle className="pb-8 pl-6 pt-16">{pageTitle}</PageTitle>
            <div className="flex flex-wrap gap-2">
                <AddCard link={`add-theme`} />
                {themes && themes.map(t => (
                    <CourseCard
                        onDelete={()=>deleteTheme(t.id)}
                        onEdit={()=>navigate(`/teachers-cabinet/theme/${t.id}/edit`)}
                    title={t.title} description={t.dateAdded} link={`/teachers-cabinet/theme/${t.id}`}>
                        {t.question_count > 0 && <CardTag text={`${t.question_count} дз`} theme="success" />}
                    </CourseCard>
                ))}
            </div>
        </section>
    )
}

export default TeachersCoursesTopics